import React, { useEffect, useState } from 'react';
import { Crown } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const LookOfTheWeek = () => {
  const [product, setProduct] = useState(null);
  const { addToCart, setIsCartOpen } = useCart();

  useEffect(() => {
    fetch(`${API_URL}/api/products`)
      .then((r) => r.json())
      .then((ps) => {
        const featured = ps.find((p) => p.isBestSeller) || ps.find((p) => p.isNew);
        setProduct(featured || null);
      })
      .catch(() => {});
  }, []);

  if (!product) return null;

  return (
    <section id="look-of-the-week" data-testid="look-of-the-week-section" className="py-16 bg-gradient-to-r from-[#001B2A] to-[#12283a]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div className="rounded-lg overflow-hidden shadow-2xl">
            <img src={product.image} alt={product.name} loading="lazy" decoding="async" className="w-full object-cover" data-testid="lotw-image" />
          </div>
          <div className="text-center md:text-left">
            <div className="inline-flex items-center gap-2 text-[#E6D7B3] uppercase tracking-[0.25em] text-sm mb-4">
              <Crown className="h-5 w-5" /> Look of the Week
            </div>
            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-white mb-4" data-testid="lotw-name">{product.name}</h2>
            <p className="text-gray-300 mb-6">{product.description}</p>
            <p className="text-3xl font-bold text-[#E6D7B3] mb-8" data-testid="lotw-price">${product.price.toFixed(2)}</p>
            <button
              data-testid="lotw-add-to-cart"
              onClick={() => { addToCart(product); toast.success(`${product.name} added to cart`); setIsCartOpen(true); }}
              className="px-10 py-4 bg-[#7B1E2B] text-white rounded-md font-semibold hover:bg-[#E6D7B3] hover:text-[#001B2A] transition-colors duration-300"
            >
              ADD TO CART
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LookOfTheWeek;
